import { normalize } from "@nova/util-strings"
import { get } from "nodash"
import { useRouter } from "next/router"
import { useCallback } from "react"

export enum PagePaths {
    Login = "/login",
    Logout = "/logout",
    Registration = "/registration",
    Reset = "/reset",
    Verification = "/verification",
    Root = "/",
}

export default function useAppPages() {
    const router = useRouter()
    const { redirect } = router.query

    const redirectToPage = useCallback(
        (pathname: string, saveRedirect = true) =>
            () => {
                if (typeof router === "undefined") {
                    return
                }

                if (router.pathname !== pathname) {
                    let newRoute = pathname
                    if (saveRedirect) newRoute += `?redirect=${encodeURIComponent(router.asPath)}`
                    router.replace(newRoute)
                }
            },
        [router]
    )
    const redirectToRootPage = useCallback(() => {
        window.location.href = normalize(redirect) || PagePaths.Root
    }, [redirect])

    return {
        redirectToLoginPage: redirectToPage(PagePaths.Login),
        redirectToLoginPageWithoutRedirect: redirectToPage(PagePaths.Login, false),
        isLoginPage: get(router, "pathname") === PagePaths.Login,

        redirectToRootPage,
        redirectToRegistrationPage: redirectToPage(PagePaths.Registration),
        isRegistrationPage: get(router, "pathname") === PagePaths.Registration,

        redirectToResetPage: redirectToPage(PagePaths.Reset, false),
        isResetPage: get(router, "pathname") === PagePaths.Reset,

        isLiveStreamPage: get(router, "pathname").startsWith("/live"),
        redirectToVerificationPage: redirectToPage(PagePaths.Verification, false),
        isVerificationPage: get(router, "pathname") === PagePaths.Verification,
    }
}
